<div class="example-container" cdkDropListGroup>
    <div class="left">
        <div class="title">
            <h4>{{'formconfiguration.visiblefields'|translateTA}}</h4>
            <div class="flex-spacer"></div>
            <button nz-button [nzType]="!enableDrag ? 'primary' : 'default'" nzShape="circle" [nz-tooltip]="'formconfiguration.movestep'|translateTA" (click)="enableDrag=!enableDrag" class="drag-class">
                <i class="fas fa-exchange-alt"></i>
            </button>
            <button nz-button nzType="primary" [nzDanger]="!enableTrash" nzShape="circle" (click)="enableTrash=!enableTrash" [nz-tooltip]="'formconfiguration.removeaddstep'|translateTA">
                <nz-icon [nzType]="enableTrash ? 'close' : 'delete'"></nz-icon>
            </button>
        </div>
        <div class="info-left">
            <nz-collapse class="accordion" cdkDropList [cdkDropListDisabled]="enableDrag" (cdkDropListDropped)="dropAccordion($event)" [cdkDropListEnterPredicate]="dragOn">
                <nz-collapse-panel *ngFor="let itemtab of tab" cdkDrag [cdkDragDisabled]="enableDrag" [nzDisabled]="getEditControl(itemtab).isFk || getDynamic(itemtab)" [nzHeader]="tabHeaderTpl" [nzShowArrow]="false">
                    <ng-template #tabHeaderTpl>
                        <div class="title-expasion" [ngStyle]="{'cursor': !enableDrag?'move':'pointer'}">
                            <div class="button-excluir" *ngIf="enableTrash" [@enterAnimation]>
                                <button nz-button nzType="primary" nzDanger nzShape="circle" nzSize="small" (click)="removeAba(itemtab);$event.stopPropagation()" [nz-tooltip]="'formconfiguration.removestep'|translateTA">
                                    <nz-icon nzType="delete"></nz-icon>
                                </button>
                            </div>
                            <div class="button-disable" [nz-tooltip]="'formconfiguration.aistep'|translateTA">
                                <nz-switch nzSize="small"
                                    [(ngModel)]="itemtab.active"
                                    (click)="changeToggle($event)"
                                    [nzDisabled]="itemtab.entityName=='multitable'">
                                </nz-switch>
                            </div>
                            <span *ngIf="!getEditControl(itemtab).editing" (click)="titleClick(itemtab,$event)" (dblclick)="titleDbClick(itemtab,$event)">{{itemtab.customName}}</span>
                            <div class="rename-field" *ngIf="getEditControl(itemtab).editing" (keydown)="onKeyDownEdit($event)" (click)="$event.stopPropagation()">
                                <input nz-input nzSize="small" type="text" #value [value]="itemtab.customName">
                                <button nz-button nzType="text" nzSize="small" *ngIf="value" (click)="saveNewName(itemtab,value.value)" aria-label="Salvar nome">
                                    <nz-icon nzType="check"></nz-icon>
                                </button>
                                <button nz-button nzType="text" nzSize="small" nzDanger *ngIf="value" (click)="cancelEdit(itemtab,$event)" aria-label="Cancelar edição">
                                    <nz-icon nzType="close"></nz-icon>
                                </button>
                                <button nz-button nzType="text" nzSize="small" [nz-tooltip]="'formconfiguration.restaurename'|translateTA" *ngIf="getEditControl(itemtab).isFk && canReturnFkName(itemtab)" (click)="returnOriginalValue(itemtab,$event)">
                                    <nz-icon nzType="rollback"></nz-icon>
                                </button>
                            </div>
                        </div>
                    </ng-template>

                    <div
                        [id]="itemtab.customName"
                        cdkDropList
                        [cdkDropListData]="visibleColumns"
                        [cdkDropListConnectedTo]="connected"
                        class="example-list-left"
                        (cdkDropListDropped)="drop($event)">
                        <div class="example-box" [id]="item" *ngFor="let item of visibleColumns | arrayFilter:'tabName':itemtab.customName:false:true" cdkDrag>{{item.columnDesc}}</div>
                    </div>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </div>


    <div class="right">
        <div class="title">
            <h4>{{'formconfiguration.availablefields'|translateTA}}</h4>
            <div class="flex-spacer"></div>
            <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'formconfiguration.movefields'|translateTA" (click)="moveSelected()">
                <i class="fas fa-exchange-alt"></i>
            </button>
        </div>
        <div class="example-box2">
            <label nz-checkbox [ngModel]="selectAll" (ngModelChange)="checkAll($event)"></label>
            <span class="item">{{'formconfiguration.selectall'|translateTA}}</span>
        </div>
        <div
            cdkDropList
            id="Disponivel"
            [cdkDropListConnectedTo]="connected"
            [cdkDropListData]="nonVisibleColumns"
            class="example-list"
            (cdkDropListDropped)="drop($event)">


            <div class="example-box" *ngFor="let item of nonVisibleColumns"  cdkDrag>
                <label nz-checkbox [ngModel]="item.checked == null || item.checked == undefined ? false : item.checked" (ngModelChange)="checkItem($event,item)"></label>
                <span class="item">{{item.columnDesc}}</span>
            </div>
        </div>
    </div>
</div>
